import { createStyles, makeStyles, Theme, Typography } from '@material-ui/core'
import MouseLeft from '_icons/mouse-left.png'
import { MeasurementType } from '../types'

type CadExHelperTutorialsProps = {
  operation?: string
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      top: theme.spacing(0),
      right: '50%',
      transform: 'translateX(50%)',
      '& img': {
        maxWidth: '2em',
        filter: theme.palette.type === 'light' ? 'invert(100%)' : 'unset',
      },
    },
  })
)
export const CadExHelperTutorials = ({
  operation,
}: CadExHelperTutorialsProps) => {
  const cn = useStyles()

  return (
    <div className={cn.root}>
      {operation === MeasurementType.Angle && (
        <Typography>
          Hold CTRL + <img src={MouseLeft} /> to select 3 vertices
        </Typography>
      )}

      {operation === MeasurementType.Dimension && (
        <Typography>
          Hold CTRL + <img src={MouseLeft} /> to select 2 vertices
        </Typography>
      )}

      {operation === '' && (
        <Typography>
          Hold CTRL + <img src={MouseLeft} /> to drag the geometry
        </Typography>
      )}
    </div>
  )
}
